@import 'styles/mixins';
@import 'styles/variables';

.form {
  padding: 0;
  border: 0;
}

.inputContainer {
  margin-left: calc(var(--collab-item-avatar-size) + var(--collab-item-avatar-gap));
}
